import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/mall/raffle/prize_description.png';
import _imports_1 from '@/assets/img/mall/raffle/btn-gray.png';
import _imports_2 from '@/assets/img/mall/raffle/btn.png';
import _imports_3 from '@/assets/img/mall/raffle/btn2.png';
import _imports_4 from '@/assets/img/mall/raffle/btn1.png';
import _imports_5 from '@/assets/icon/close_ic.svg';
import _imports_6 from '@/assets/img/mall/raffle/back_home.png';
const _withScopeId = n => (_pushScopeId("data-v-7bd941ce"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "mallRaffle" };
const _hoisted_2 = { class: "timeWrapper" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = { class: "lotteryWrapper" };
const _hoisted_6 = { class: "list" };
const _hoisted_7 = ["src"];
const _hoisted_8 = { class: "quantity" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { key: 1 };
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
    key: 0,
    src: _imports_1,
    alt: ""
};
const _hoisted_13 = {
    key: 1,
    src: _imports_2,
    alt: ""
};
const _hoisted_14 = { class: "info" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("dt", null, "中奖记录", -1));
const _hoisted_16 = { class: "listBox" };
const _hoisted_17 = { class: "listBin" };
const _hoisted_18 = { class: "winlist" };
const _hoisted_19 = { class: "prizeName" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, " 一份；", -1));
const _hoisted_21 = { class: "prizeName" };
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, " 一份；", -1));
const _hoisted_23 = { class: "resultWrapper" };
const _hoisted_24 = { class: "content" };
const _hoisted_25 = { class: "lottery" };
const _hoisted_26 = { class: "img" };
const _hoisted_27 = ["src"];
const _hoisted_28 = { class: "name" };
const _hoisted_29 = { class: "btnBox" };
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_3,
    alt: ""
}, null, -1));
const _hoisted_31 = [
    _hoisted_30
];
const _hoisted_32 = ["onClick"];
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_4,
    alt: ""
}, null, -1));
const _hoisted_34 = [
    _hoisted_33
];
const _hoisted_35 = { class: "descriptWrapper" };
const _hoisted_36 = { class: "content" };
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "title" }, "奖品描述", -1));
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_5,
    alt: ""
}, null, -1));
const _hoisted_39 = [
    _hoisted_38
];
const _hoisted_40 = ["innerHTML"];
const _hoisted_41 = ["onClick"];
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_6,
    alt: ""
}, null, -1));
const _hoisted_43 = [
    _hoisted_42
];
import AppShare from '@/components/common/AppShare.vue';
import { ref, onMounted, getCurrentInstance } from 'vue';
import { appPort, getUserId, userLogin, jumpModuleApp, weixinShare, setWebBackground, hiddenAppNavBar } from '@/widget';
import { useRoute, useRouter } from 'vue-router';
import { getRaffleDetail, mallRaffle, getWinningList } from '@/api/mall';
import { findIndex } from 'lodash-es';
import { Toast } from 'vant';
import { hostPath } from '@/public/utils/basePath';
import { getUserInfo } from '@/api/user';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { proxy: { $dialog, $showLoading, $hideLoading } } = getCurrentInstance();
        const route = useRoute();
        const router = useRouter();
        const isApp = appPort();
        const shareInfo = ref({
            title: '',
            desc: '',
            image: '',
            url: location.href
        });
        const list = ref([]);
        const actId = route.params.id;
        const userId = getUserId();
        const actStatus = ref(1); // 0未开始，1进行中，2已结束，3已抽奖
        const actTime = ref('');
        const description = ref('');
        const activityName = ref('');
        const share = ref(false);
        const unusedCount = ref(3);
        const lotteryPermission = ref(false); // 是否有抽奖权限
        const isMallActivity = ref(false); // 是否是商城抽奖活动
        const getDetail = () => {
            getRaffleDetail(actId, userId).then((res) => {
                if (res.code == 200) {
                    list.value = res.data.prizeList;
                    actStatus.value = res.data.status;
                    actTime.value =
                        res.data.startDate.replace(/-/g, '.') +
                            ' - ' +
                            res.data.endDate.replace(/-/g, '.');
                    if (res.data.share) {
                        let { url, title, desc, image } = res.data.shareVo;
                        shareInfo.value = { url: url || location.href, title, desc, image };
                        if (!isApp) {
                            weixinShare(shareInfo.value);
                        }
                    }
                    unusedCount.value = res.data.unusedCount;
                    activityName.value = res.data.activityName;
                    description.value = res.data.describe;
                    share.value = res.data.share;
                    lotteryPermission.value = res.data.lotteryPermission;
                    isMallActivity.value = res.data.isMallActivity;
                    getUser();
                }
            });
        };
        // 个人信息
        const userInfo = ref({});
        const getUser = () => {
            let userId = getUserId();
            getUserInfo(userId).then((res) => {
                if (res.code == 200) {
                    userInfo.value = res.data.user;
                }
            });
        };
        getDetail();
        const ind = ref(-1);
        let num = 1;
        let timer;
        let result = -1; // 获奖奖品在讲评列表中的下标
        // 展示抽奖结果
        const showResult = ref(false);
        const setTimer = (duration) => {
            if (timer) {
                clearInterval(timer);
            }
            timer = setInterval(() => {
                num++;
                ind.value = num % 9;
                if (num > 36) {
                    // -1已删除，0未开始，1已结束，2已抽过，3当天超过3次，4中奖，5未中奖
                    // @ts-ignore
                    if (prizeInfo.value.status != 4) {
                        clearInterval(timer);
                        ind.value = -1;
                        getDetail();
                    }
                    loading = false;
                    if (prizeInfo.value.status == 0) {
                        Toast('活动未开始');
                    }
                    else if (prizeInfo.value.status == 1) {
                        Toast('活动已结束');
                    }
                    else if (prizeInfo.value.status == 2) {
                        Toast('您已参与抽奖');
                    }
                    else if (prizeInfo.value.status == 3) {
                        Toast('您当天已参与了3次抽奖，请明天再来');
                    }
                    else if (prizeInfo.value.status == 4) {
                        setTimer(300);
                    }
                    else if (prizeInfo.value.status == 6) {
                        if (isApp) {
                            Toast('您没有权限抽奖');
                        }
                        else {
                            let msg = '当前账号 ' + (userInfo.value.userName || '') + ' (' + (userInfo.value.phone?.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$2')) + ') 没有权限抽奖，是否切换账号？';
                            $dialog.confirm({
                                message: msg,
                                theme: 'round-button',
                                confirmButtonText: '切换账号',
                                cancelButtonText: '关闭'
                            }).then(() => {
                                userLogin();
                            }).catch(() => {
                            });
                        }
                    }
                    else if (prizeInfo.value.status == -1) {
                        Toast('活动已删除');
                    }
                    else {
                        Toast('未中奖');
                    }
                    if (ind.value == result && ind.value != -1) {
                        // 展示获奖奖品
                        showResult.value = true;
                        getDetail();
                        clearInterval(timer);
                    }
                }
                if (num > 1000) {
                    // 超出一定时间停止计时器
                    clearInterval(timer);
                    ind.value = -1;
                }
            }, duration);
        };
        let loading = false;
        const prizeInfo = ref({});
        const submit = () => {
            if (loading) {
                return;
            }
            if (!userId) {
                userLogin();
                return;
            }
            if (!lotteryPermission.value) {
                if (isApp) {
                    Toast('您没有权限抽奖');
                }
                else {
                    let msg = '当前账号 ' + (userInfo.value.userName || '') + ' (' + (userInfo.value.phone?.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$2')) + ') 没有权限抽奖，是否切换账号？';
                    $dialog.confirm({
                        message: msg,
                        theme: 'round-button',
                        confirmButtonText: '切换账号',
                        cancelButtonText: '关闭'
                    }).then(() => {
                        userLogin();
                    }).catch(() => {
                    });
                }
                return;
            }
            if (actStatus.value != 1) {
                // 0未开始 2已结束，3已抽奖
                if (actStatus.value == 0) {
                    Toast('活动未开始');
                }
                else if (actStatus.value == 2) {
                    Toast('活动已结束');
                }
                else {
                    Toast('你已参与抽奖');
                }
                return;
            }
            loading = true;
            ind.value = 0;
            num = 0;
            setTimer(50);
            mallRaffle(actId, userId)
                .then((res) => {
                if (res.code == 200) {
                    prizeInfo.value = res.data;
                    if (res.data.status == 4) {
                        result = findIndex(list.value, { prizeId: prizeInfo.value.prizeId });
                    }
                }
                else {
                    loading = false;
                    clearInterval(timer);
                    ind.value = -1;
                }
            })
                .catch(() => {
                clearInterval(timer);
                ind.value = -1;
                loading = false;
            });
        };
        const toRecord = () => {
            if (isApp) {
                jumpModuleApp({
                    typeId: 'h5',
                    url: `${hostPath}/learn/mall/raffle/record`
                });
            }
            else {
                router.push(`/mall/raffle/record`);
            }
        };
        // 进入商城首页
        const toHome = () => {
            if (isApp) {
                jumpModuleApp({ typeId: 'mall_list' });
            }
            else {
                location.assign(`${hostPath}/mall`);
            }
        };
        const showDesc = ref(false); // 是否展示活动描述
        const winList = ref([]);
        getWinningList(Number(actId), { userId }).then((res) => {
            if (res.code == 200) {
                winList.value = res.data.winningList;
            }
        });
        onMounted(() => {
            if (isApp) {
                hiddenAppNavBar();
                // 设置背景色
                setWebBackground('ff3c61');
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_unref(isApp))
                    ? (_openBlock(), _createBlock(AppShare, {
                        key: 0,
                        pageTitle: activityName.value,
                        shareInfo: shareInfo.value,
                        color: 'white',
                        share: share.value,
                        domStyle: { top: '0.32rem' },
                        titleColor: 'white'
                    }, null, 8, ["pageTitle", "shareInfo", "share", "domStyle"]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, _toDisplayString(actTime.value), 1),
                _createElementVNode("div", {
                    class: "descBtn",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (showDesc.value = true), ["stop"]))
                }, _hoisted_4),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("ul", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, key) => {
                            return (_openBlock(), _createElementBlock("li", {
                                class: _normalizeClass({ active: ind.value == key })
                            }, [
                                _createElementVNode("img", {
                                    src: item.prizeImage,
                                    alt: ""
                                }, null, 8, _hoisted_7)
                            ], 2));
                        }), 256))
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        (!_unref(userId))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "登录后抽奖"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_10, "剩余次数：" + _toDisplayString(unusedCount.value), 1))
                    ]),
                    _createElementVNode("div", {
                        class: "btn",
                        onClick: _withModifiers(submit, ["stop"])
                    }, [
                        (actStatus.value == 3)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                            : (_openBlock(), _createElementBlock("img", _hoisted_13))
                    ], 8, _hoisted_11)
                ]),
                _createElementVNode("dl", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("dd", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("ul", _hoisted_18, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(winList.value, (item) => {
                                    return (_openBlock(), _createElementBlock("li", null, [
                                        _createElementVNode("span", null, _toDisplayString(item.userName) + " 获得 ", 1),
                                        _createElementVNode("span", _hoisted_19, _toDisplayString(item.prizeName), 1),
                                        _hoisted_20
                                    ]));
                                }), 256)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(winList.value.slice(0, 10), (item) => {
                                    return (_openBlock(), _createElementBlock("li", null, [
                                        _createElementVNode("span", null, _toDisplayString(item.userName) + " 获得 ", 1),
                                        _createElementVNode("span", _hoisted_21, _toDisplayString(item.prizeName), 1),
                                        _hoisted_22
                                    ]));
                                }), 256))
                            ])
                        ])
                    ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("img", {
                                    src: prizeInfo.value.prizeImage,
                                    alt: ""
                                }, null, 8, _hoisted_27)
                            ]),
                            _createElementVNode("div", _hoisted_28, _toDisplayString(prizeInfo.value.prizeName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", {
                                class: "btn",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (showResult.value = false), ["stop"]))
                            }, _hoisted_31),
                            _createElementVNode("div", {
                                class: "btn",
                                onClick: _withModifiers(toRecord, ["stop"])
                            }, _hoisted_34, 8, _hoisted_32)
                        ])
                    ])
                ], 512), [
                    [_vShow, showResult.value]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                        _hoisted_37,
                        _createElementVNode("div", {
                            class: "closeBtn",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (showDesc.value = false), ["stop"]))
                        }, _hoisted_39),
                        _createElementVNode("div", {
                            class: "desc",
                            innerHTML: description.value.replace(/(\r\n|\r)/g, '<br />')
                        }, null, 8, _hoisted_40)
                    ])
                ], 512), [
                    [_vShow, showDesc.value]
                ]),
                (isMallActivity.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "homeBtn",
                        onClick: _withModifiers(toHome, ["stop"])
                    }, _hoisted_43, 8, _hoisted_41))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
